import { useState, useContext, useEffect } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { Auth } from 'aws-amplify'

// @mui material components
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import LinearProgress from '@mui/material/LinearProgress'

// Soft UI Dashboard PRO React example components
import OnboardingLayout from 'components/LayoutContainers/OnboardingLayout'
import OnboardingNavbar from 'components/Navbars/OnboardingNavbar'
import OnboardingFooter from 'components/OnboardingFooter'
import { useNavigate } from 'react-router-dom'
import { callZapier } from 'utils/zapier/callZapier'

import circleBG from 'assets/images/circles.svg'
import parcoDog from 'assets/images/parcoDog.svg'
import laptopMockup from 'assets/images/laptopMockup_Jun20.png'
import phoneMockup from 'assets/images/phoneMockup.png'
import { Link } from '@mui/material'
import { checkUserLoggedIn } from 'utils/aws/authService'

function OnboardingSelector() {
  const { intakeState, updateUser, updateIntakeStateAtKey } =
    useContext(IntakeContext)
  const navigate = useNavigate()
  useEffect(() => {
    checkUserLoggedIn(navigate)
  }, [navigate])

  const [isMobile, setIsMobile] = useState(window.innerWidth < 575)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 575)
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const zapierNotificationOfLogin = async () => {
      try {
        callZapier({
          user: intakeState,
          hookUrl: 'https://hooks.zapier.com/hooks/catch/15607509/3fx8p4q/',
          payload: {
            user: {
              firstName: intakeState.firstName
                ? intakeState.firstName
                : 'Name Not',
              lastName: intakeState.lastName
                ? intakeState.lastName
                : 'Yet Submitted',
              email: intakeState.email,
            },
          },
          sendNotification: false,
        })
      } catch (err) {
        console.log(err)
      }
    }
    zapierNotificationOfLogin()
    checkUserLoggedIn()
    return () => {}
  }, [intakeState, navigate])

  //make a new page that is a navigation page for dashboard or onboarding using the useNaviate function

  return (
    <OnboardingLayout>
      {/* <DashboardNavbar /> */}
      <OnboardingNavbar />
      <Box sx={{ width: '100%', overflow: 'hidden', margin: 'auto' }}>
        <LinearProgress
          variant="determinate"
          value={0}
          color="dark"
          sx={{
            height: '8px',
            overflow: 'hidden',
            borderRadius: '0px',
          }}
        />
      </Box>
      <Box
        sx={{
          minHeight: { xs: 'calc(100vh - 117px)', sm: 'calc(100vh - 125px)' },
        }}
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={6}>
            <Box
              p={{ xs: 4, md: 12 }}
              pb={{ xs: 5, md: 12 }}
              sx={{
                background: '#fff',
                minHeight: { lg: 'calc(100vh - 127px)' },
                paddingBottom: { lg: '100px' },
              }}
            >
              <Box sx={{ textAlign: 'left' }}>
                <Box mb={{ xs: 0, md: 1 }}>
                  <Typography
                    variant="h2"
                    fontWeight="400"
                    fontSize={isMobile ? '30px' : '40px'}
                  >
                    Plan Today,
                  </Typography>
                </Box>
                <Box mb={{ xs: 2, md: 3 }}>
                  <Typography
                    variant="h2"
                    fontWeight="900"
                    fontSize={isMobile ? '30px' : '40px'}
                  >
                    Secure Tomorrow
                  </Typography>
                </Box>
                {isMobile ? (
                  <>
                    <Typography
                      variant="body1"
                      sx={{ lineHeight: '1.2' }}
                      mb={3}
                    >
                      Welcome to PARCO, where your Federal retirement planning
                      is{' '}
                      <b>simplified, insightful, and tailored just for you!</b>
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography
                      variant="body1"
                      sx={{ lineHeight: '1.2' }}
                      mb={3}
                    >
                      Welcome to PARCO, where your{' '}
                      <b>
                        Federal retirement planning is simplified, insightful,
                        and tailored just for you!
                      </b>{' '}
                      Our platform is designed to provide you with powerful
                      visuals, intuitive tools, and most importantly, the
                      specific <b>ANSWERS</b> to secure your future.
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ lineHeight: '1.2' }}
                      mb={3}
                    >
                      Whether you're just starting out or refining your
                      strategy, PARCO offers{' '}
                      <b>
                        AI-powered personalized recommendations to guide you.
                      </b>
                    </Typography>
                  </>
                )}
                {/* <img
                  src={parcoDog}
                  style={{
                    maxWidth: '400px',
                    display: 'block',
                    margin: 'auto',
                  }}
                /> */}
              </Box>
              <Box mt={{ xs: 3, md: 5 }} width="100%" display="flex">
                <Link href="/dashboard">
                  <Button
                    variant="contained"
                    sx={[
                      {
                        fontSize: '15px',
                        padding: '12px 24px',
                        backgroundColor: '#344767',
                        color: '#fff',
                        fontWeight: 'normal',
                        boxShadow: 'none',
                        textTransform: 'capitalize',
                        letterSpacing: 0.5,
                        borderRadius: '6px',
                        marginRight: '1rem',
                      },
                      {
                        '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                          transform: 'none',
                          backgroundColor: '#293852',
                          boxShadow: 'none',
                        },
                      },
                    ]}
                  >
                    Sign In
                  </Button>
                </Link>
                <Link href="/onboarding-flow">
                  <Button
                    variant="contained"
                    sx={[
                      {
                        fontSize: '15px',
                        padding: '12px 24px',
                        backgroundColor: '#4CAF50',
                        color: '#fff',
                        fontWeight: 'normal',
                        boxShadow: 'none',
                        textTransform: 'capitalize',
                        letterSpacing: 0.5,
                        borderRadius: '6px',
                      },
                      {
                        '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                          transform: 'none',
                          backgroundColor: '#449d48',
                          boxShadow: 'none',
                        },
                      },
                    ]}
                  >
                    Create Account
                  </Button>
                </Link>
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            sx={{
              backgroundImage: `url(${circleBG})`,
              backgroundPosition: 'center',
            }}
          >
            <Grid
              justifyContent="center"
              sx={{ px: { xs: 0, sm: 2, md: 6 }, pt: { xs: 0, sm: 6, md: 12 } }}
              pb={{ xs: 0, sm: 6, md: 24 }}
            >
              <img
                src={isMobile ? phoneMockup : laptopMockup}
                style={{
                  maxWidth: '800px',
                  width: '100%',
                  display: 'block',
                  margin: 'auto',
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* <Footer /> */}
      <OnboardingFooter />
    </OnboardingLayout>
  )
}

export default OnboardingSelector
